import { styled } from "@mui/material/styles";


export const Homestyle = styled("div")(({ theme }) => ({
      '& .logo-nav':{
        width:"180px",
        height:"64px",
        marginLeft:"20%",
        marginRight:"auto",
      },
      '& .sideshdow':{
        background:" #FFFFFF",
boxShadow: "0px 10px 15px rgba(0, 0, 0, 0.25)",
      },
      '& .paper-setting':{
        padding:"25px",
        textAlgin:"center",
        height:"100vh",
        
      },
      '& .searchiput':{
        fontFamily:"Inter-Regular !important ",
        fontSize:"16px",
        height:"48px !important ",
        '&::placeholder': {
          fontFamily:"Inter-Regular",
          fontSize:"16px",
         
        },
        '& .MuiOutlinedInput-root': {
          fontFamily:"Inter-Regular !important ",
          color:"#344054",
          height:"48px !important ",
          '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
          },
        },
      },
      '& .list-man-nav':{
        padding:"unset",
        '& .MuiListItem-root':{
          padding:"unset",
          width:"unset",
         
        },
      },
      '& .list-top':{
        marginTop:"14px",
        '& .List-main-inner':{
          width:"100%",
      
          display:"inline-flex",
          height:"40px",
          borderRadius:"6px",

        },
        '& .MuiListItem-root':{
          padding:"unset",
          width:"unset",
          paddingLeft:"12px",
        },
        '& .MuiButton-textPrimary':{
          textTransform: "capitalize",
          color:theme.palette.warning.main,
          background:theme.palette.warning.light,
        },
        '& .user-setting':{
          position: "relative",
          top: "3px",
        }

      },


      '& .list-top-2':{
        marginTop:"8px",
        '& .List-main-inner':{
          width:"100%",
          display:"inline-flex",
          height:"40px",
          borderRadius:"6px",

        },
        '& .MuiListItem-root':{
          padding:"unset",
          width:"unset",
          paddingLeft:"12px",
        },
        '& .MuiButton-textPrimary':{
          textTransform: "capitalize",
          color:theme.palette.primary.dark,
        },
        '& .MuiTypography-root':{
            fontFamily:"Inter-Medium"
        },
        '& .user-setting':{
          position: "relative",
          top: "3px",
        }

      },
      '& .nav-card':{
          background:theme.palette.warning.light,
          padding:"15px",
          marginTop:"130px",
      },
      '& .ring-text':{
        marginTop:"10px",
      },
      '& .click-here':{
        color:theme.palette.warning.main,
        borderBottom: "1px solid #D32028 ",
        cursor: "pointer",
      },
      '& .appbar':{
        boxShadow: "none",
        background: "#ffffff",
        borderBottom: "1px solid #e4e7ec",
        backdropFilter: "blur(8px)",
        '& .MuiList-root':{
          display:"inline-flex",
        },
        '& .MuiListItem-root':{
          padding:"unset",
        },
        // Below Sidebar.jsx's mobile breakpoint (see Sidebar.css/breakpoints.js — 767px),
        // there's no persistent rail, only its own fixed hamburger trigger at top-left
        // (12px + 40px + gap). Reserve the same space here so the Toolbar's own content
        // doesn't render underneath/overlapping it.
        '@media (max-width: 767px)': {
          '& .MuiToolbar-root': {
            paddingLeft: '64px',
          },
        },
        '& .backlft':{
          paddingLeft:"8px",
          fontFamily: "Outfit",
          fontWeight: 500,
          fontSize: "14px",
          color: "#374151",
        },
        // Was targeted at MUI's own generated ".MuiButton-outlinedPrimary" class before
        // the "Back" button switched to the shared Button component (shared/Button) —
        // retargeted at the className it now renders with instead.
        '& .back-button':{
          fontSize:"13px",
          color:"#374151",
          fontFamily:"Outfit",
          fontWeight: 500,
          borderRadius:"10px",
          height:"36px",
          textTransform: "capitalize",
          border:"1.5px solid #e5e7eb",
          boxShadow: "none",
          marginTop:"0px",
          background: "#fff",
          transition: "border-color 0.18s, background 0.18s, box-shadow 0.18s",
          '&:hover': {
            border: "1.5px solid #ee8f94",
            background: "#fff5f5",
            boxShadow: "0 2px 8px rgba(211,32,40,0.1)",
            color: "#D32028",
          },
        },
        // Hover for the notification bell (also the shared Button component) — its base
        // background/border are set inline (Notifications.js), but :hover needs real CSS.
        '& .notification-bell-button': {
          transition: "background-color 0.18s, border-color 0.18s",
          '&:hover': {
            background: "#fee2e2",
            borderColor: "#D32028",
          },
        },
      },
      '& .menuicon':{
        color:"#667085",
      },

      '& .nextbtn':{
        textTransform: "capitalize",
        width:"326px",
        height:" 50px",
        fontSize:"24px",
        fontFamily:"Outfit-Regular",
        borderRadius:"60px",
        textAlgin:"center",
        position:"relative",
        '& .next-arrow':{
          position:" absolute",
          right: "21px",
        },
      },
      '& .chose-file':{
        textTransform: "capitalize",
        width:"153px",
        height:" 44px",
        fontSize:"16px",
        fontFamily:"Outfit-Regular",
        color:theme.palette.primary.dark,
        background:"#F3F3F3",
        border: "1px solid #D0D5DD",
      
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
        "&:hover":{
          color:theme.palette.primary.dark,
          background:"#F3F3F3",
        },
      },
      '& .linkdco':{      
    textDecoration: "none",
      },


//  small down media started

[theme.breakpoints.down('sm')]: {
  '& .chose-file':{
    width:"100%",

  },
},
}));
